import {
  HttpInterceptor,
  HttpEvent,
  HttpRequest,
  HttpHandler,
  HTTP_INTERCEPTORS,
  HttpErrorResponse,
} from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import {
  SnackBarService,
  StoreService,
  WebsocketService,
} from '../services';
import {Observable, of, throwError} from 'rxjs';
import { catchError } from 'rxjs/operators';

@Injectable()
export class TokenHttpInterceptor implements HttpInterceptor {

  constructor(
    private readonly store: StoreService,
    private readonly ws: WebsocketService,
    private readonly sbs: SnackBarService,
    private readonly router: Router,
  ) {
  }

  public intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const token = this.store.getToken();

    // Дополнительные параметры текущего запроса
    let requestOptions = {};

    if (token) {
      requestOptions = {
        setHeaders: {
          Authorization: `Bearer ${token}`,
        },
      };
    }

    const currentRequest = request.clone(requestOptions);

    return next.handle(currentRequest)
      .pipe(
        catchError((err: HttpErrorResponse) => {
          if (err.status === 401) {
            this.store.clearToken();
            this.router.navigate(['login']);
            this.ws.upConnection.next(false);
            this.sbs.error('Ошибка авторизации.');
          } else {
            this.sbs.error(err.error ? err.error.Error : err.message);
          }

          return throwError(err);
        })
      );
  }
}

export const AuthInterceptor = {
  provide: HTTP_INTERCEPTORS,
  useClass: TokenHttpInterceptor,
  multi: true,
};
